import React, { useEffect, useState } from "react";
import styles from "./Menu.module.scss";
import { MenuItemType, MenuType } from "../../../types/baseTypes";
import MenuItem from "./MenuItem/MenuItem";
import { useKeyboardNavigation } from "./keyboard-navigation";
import { Post } from "@/wp/types/client";

interface MenuProps {
  menu: MenuType;
  pageData?: Post;
}

export type MenuParentType = MenuItemType | undefined;

export const Menu = ({ menu, pageData }: MenuProps) => {
  const [currentSubmenu, setCurrentSubmenu] = useState<MenuParentType>();

  const { menuRef, items, focusedItem, keyDown, controlMenu } =
    useKeyboardNavigation({
      menu,
      setCurrentSubmenu,
      type: "menu",
      subMenu: undefined,
    });

  useEffect(() => {
    const handleFocusChange = (event: FocusEvent) => {
      if (!menuRef.current?.contains(event.target as Node)) {
        setCurrentSubmenu(undefined);
      }
    };

    document.addEventListener("focusin", handleFocusChange);

    return () => {
      document.removeEventListener("focusin", handleFocusChange);
    };
  }, [menuRef]);

  return (
    <ul
      ref={menuRef}
      role="menubar"
      aria-label="Hauptmenü"
      className={`${styles["main-menu"]}`}
      onKeyDown={keyDown}
    >
      {menu &&
        Array.isArray(menu.items) &&
        menu.items.map((item, key) => {
          if (!items.current[key]) {
            items.current[key] = React.createRef<HTMLLIElement>();
          }
          return (
            <MenuItem
              item={item}
              key={key}
              pageData={pageData}
              currentSubmenu={currentSubmenu}
              setCurrentSubmenu={setCurrentSubmenu}
              parentSubMenu={undefined}
              subMenu={item}
              tabIndex={key === focusedItem.current ? 0 : -1}
              itemRef={items.current[key]}
              controlParentMenu={controlMenu}
            />
          );
        })}
    </ul>
  );
};
